import TimeSheetModel from '@/models/entities/TimeSheetModel';
import { TIME_SHEET_SUMMARIES } from '@/models/entities/TimeSheetSummaryModel';
import { listPage } from '@/models/listPage';
import { fetchSummaries } from '@/models/summaries';

/**
 * Brouillons des employés de la page « À soumettre » (useRelatedByIds) : [memberId => son brouillon de la période, ou
 * null s'il n'a pas encore de feuille], une requête avec leur total. Au plus une feuille par employé et par période.
 */
export function draftsLoader(periodId: number) {
  return async (memberIds: string[]): Promise<Map<number, TimeSheetModel | null>> => {
    const drafts = await listPage(
      TimeSheetModel,
      { filters: { member: memberIds, period: periodId }, page: 1, itemsPerPage: memberIds.length, partial: true },
      [],
      (sheets) => fetchSummaries(sheets, TIME_SHEET_SUMMARIES),
    );

    return new Map(
      memberIds.map((id) => [Number(id), drafts.models.find((sheet) => sheet.memberId === Number(id)) ?? null]),
    );
  };
}
